module.exports = __webpack_public_path__ + "static/media/light_fixture_spotlight_led.7d2dd288.png";